// extracted by mini-css-extract-plugin
module.exports = {"component":"Logo_component__47qzG","inner":"Logo_inner__avBuY","clickable":"Logo_clickable__l_mET"};